import { registerComponent } from '@gig/magic-common';
import RedemptionsTransactionsComponent from './redemptions.vue.js';

var RedemptionTransactions = registerComponent(RedemptionsTransactionsComponent);

export { RedemptionTransactions };
